export const environment = {
    apiBaseUrl: "https://api.regionaltechhub.org.au",
    appBaseUrl: "https://app.regionaltechhub.org.au",
    google_map_API_key: "AIzaSyA34MsnLMw_bkbdke3UMAbxJ4DnEZUI0DM",
};
